import { render } from "./MyFooterA.vue?vue&type=template&id=faf8b682&scoped=true"
const script = {}

import "./MyFooterA.vue?vue&type=style&index=0&id=faf8b682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf8b682"]])

export default __exports__